import { space, tokPx } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'

const Root = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${tokPx('primitives_breakpoint_m_min')}) {
    flex-direction: row;
  }

  padding: ${space('primitives_space_24')};
  border: 2px solid #e7e0d7;
  border-radius: ${tokPx('primitives_space_4')};
  background-color: #f3f0ed;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-top: ${space('primitives_space_12')};

  @media (min-width: ${tokPx('primitives_breakpoint_m_min')}) {
    margin-top: 0;
    max-width: 800px;
    margin-right: auto;
    margin-left: ${space('primitives_space_16')};
  }
`

const TitleDescription = styled.div`
  display: flex;
  flex-direction: column;
`

export default { Root, Content, TitleDescription }
